
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[slug]/prize",
      function () {
        return require("private-next-pages/[slug]/prize/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[slug]/prize"])
      });
    }
  